/**
 * Side effect, imported first by main.ts: moves an account token out of the
 * address bar while the boot graph evaluates (see @/utils/urlToken). Keep its
 * imports to @/utils/urlToken, so nothing it pulls in evaluates ahead of the
 * scrub with the token still in the URL.
 */
import { stashUrlToken, type UrlTokenKey } from '@/utils/urlToken'

// The token routes at the router root, matched as the router does: case
// sensitive, one trailing slash allowed. tests/router/urlToken.spec.ts holds
// these to the route records.
export const QUERY_TOKEN_PATHS: Readonly<Record<string, UrlTokenKey>> = {
  '/verify-email': 'verifyEmail',
  '/reset-password': 'resetPassword'
}
export const INVITE_TOKEN_PATH = /^\/invite\/([^/]+)\/?$/

// vue-router's decoding: the raw text when it is not valid percent-encoding.
function decode(text: string): string {
  try {
    return decodeURIComponent(text)
  } catch {
    return text
  }
}

function scrub(): void {
  const { pathname, search, hash } = window.location
  const queryKey = QUERY_TOKEN_PATHS[pathname.replace(/(.)\/$/, '$1')]
  const invite = INVITE_TOKEN_PATH.exec(pathname)
  let path = pathname
  let query = search

  if (queryKey) {
    const kept: string[] = []
    const tokens: string[] = []
    for (const part of search.slice(1).split('&')) {
      const [name, ...value] = part.split('=')
      if (decode(name.replace(/\+/g, ' ')) === 'token') {
        tokens.push(decode(value.join('=').replace(/\+/g, ' ')))
      } else if (part) {
        kept.push(part)
      }
    }
    if (tokens.length === 0) return
    // The first value, as the guard reads it; an empty one is only stripped.
    if (tokens[0]) stashUrlToken(queryKey, tokens[0])
    query = kept.length ? `?${kept.join('&')}` : ''
  } else if (invite) {
    stashUrlToken('inviteAccept', decode(invite[1]))
    path = '/invite'
  } else {
    return
  }

  // createWebHistory reads the location later, so the router starts clean.
  history.replaceState(history.state, '', path + query + hash)
}

if (typeof window !== 'undefined') scrub()
